import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { googleCalendarApi } from '../services/googleCalendar';

export const googleCalendarKeys = {
  status: ['google-calendar', 'status'] as const,
};

/**
 * Get Google Calendar integration status
 */
export function useGoogleCalendarStatus() {
  return useQuery({
    queryKey: googleCalendarKeys.status,
    queryFn: () => googleCalendarApi.getStatus(),
  });
}

/**
 * Toggle Google Calendar sync active/inactive
 */
export function useToggleGoogleCalendar() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => googleCalendarApi.toggle(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: googleCalendarKeys.status });
    },
  });
}

/**
 * Disconnect Google Calendar
 */
export function useDisconnectGoogleCalendar() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => googleCalendarApi.disconnect(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: googleCalendarKeys.status });
    },
  });
}
